import axios from 'axios'
import makeConfig from './token'
import { apiURL } from '../util/config'
import { useSelector } from 'react-redux'

const useUserService = () => {
  const cart = useSelector((state) => state.cart)
  const baseURL = `${apiURL}/users`

  const create = (newUser) => {
    const request = axios.post(baseURL, newUser)
    return request.then((response) => response)
  }
  const tryToVerifyEmail = (token) => {
    const config = makeConfig()
    const request = axios.post(`${baseURL}/verify_email`, { token }, config)
    return request
  }
  const requestNewEmailToken = (token) => {
    const config = makeConfig()
    const request = axios.get(`${baseURL}/new_email_token`, config)
    return request
  }
  const addAddress = (newAddress) => {
    const config = makeConfig()
    const request = axios.post(`${baseURL}/address`, newAddress, config)
    return request
  }
  const editAddress = (newAddress) => {
    const config = makeConfig()
    const request = axios.put(`${baseURL}/address`, newAddress, config)
    return request
  }
  const deleteAddress = (id) => {
    const config = makeConfig()
    const request = axios.delete(`${baseURL}/address/${id}`, config)
    return request
  }
  const login = (email, password) => {
    const request = axios.post(`${apiURL}/login`, {
      email,
      password,
      cart,
    })
    return request
  }

  const forgotPassword = (email) => {
    const request = axios.post(`${baseURL}/initiate_reset_password`, {
      email,
    })
    return request
  }

  const resetPassword = ({ token, password }) => {
    const request = axios.post(`${baseURL}/reset_password`, {
      token,
      password,
    })
    return request
  }
  const changePassword = ({ oldPassword, newPassword }) => {
    const config = makeConfig()
    const request = axios.post(
      `${baseURL}/change_password`,
      {
        oldPassword,
        newPassword,
      },
      config
    )
    return request
  }
  const deleteAccount = ({ email, password }) => {
    const config = makeConfig()
    const request = axios.delete(`${baseURL}`, {
      data: { email, password },
      headers: config.headers,
    })
    return request
  }
  return {
    create,
    login,
    addAddress,
    forgotPassword,
    resetPassword,
    changePassword,
    editAddress,
    deleteAddress,
    deleteAccount,
    tryToVerifyEmail,
    requestNewEmailToken,
  }
}
export default useUserService
